import { List } from 'immutable';
import AgreementVersion from '../../../interfaces/output/agreementVersion';
import { ensure } from '../../../utils/arrayUtils';
import LanguageUtils from '../../../utils/LanguageUtils';
import ValidationModel from '../../../utils/validationModel';
import ValidationUtils from '../../../utils/validationUtils';

const messages = {
    requiredFields: LanguageUtils.createMessage('Validation error general'),
    invalidDates: LanguageUtils.createMessage('Invalid date range'),
    invalidDateFormat: LanguageUtils.createMessage('Invalid date format')
};

export default class AgreemenStep2Validation extends ValidationUtils {

    static validateRequiredDate(inputDate: Date | undefined): boolean {

        return !!inputDate;
    }

    static validateInputDateStart(agreementVersion: AgreementVersion | undefined): boolean {
        const dateStart = agreementVersion?.validFromDate;
        const dateTo = agreementVersion?.validToDate;

        return this.validateDateTimeRangeStart(dateStart, dateTo);
    }

    static validateInputDateEnd(agreementVersion: AgreementVersion | undefined): boolean {
        const dateStart = agreementVersion?.validFromDate;
        const dateTo = agreementVersion?.validToDate;

        return this.validateDateTimeRangeTo(dateStart, dateTo);
    }

    static validateAgreementVersionForm(agreementVersion: AgreementVersion | undefined): ValidationModel {
        const validationModel = {
            validationMessages: List(),
            isValid: true
        } as ValidationModel;

        const { validFromDate,
            validToDate
        } = agreementVersion as AgreementVersion;

        const requiredFields =
            this.validateRequiredDate(validFromDate) &&
            this.validateRequiredDate(validToDate);

        if(!requiredFields) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.requiredFields);
        }

        const endDate = agreementVersion?.validToDate;
        const validDates = endDate ? this.validateInputDateStart(agreementVersion) &&
            this.validateInputDateEnd(agreementVersion) : true;

        if(!validDates) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.invalidDates);
        }

        if(!requiredFields) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.requiredFields);
        }
        
        const formatedDate = this.validateDateFormat(validFromDate) &&
        this.validateDateFormat(validToDate);

        if(!formatedDate) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.invalidDateFormat);
        }

        return validationModel;
    }
}
